import { ISection } from '@creditflowresearch/uilib/Section';

class AdapterService {
  static flattenSectionsGrid(sectionsGrid: ISection[][][]): ISection[] {
    return sectionsGrid.flatMap((row) => row.flatMap((column) => column));
  }

  static combineRowsForDesktop(sectionsGrid: ISection[][][]): ISection[][][] {
    const combined: ISection[][][] = [];
    const { length } = sectionsGrid;

    for (let i = 0; i < length; i += 2) {
      const nextRow = sectionsGrid[i + 1];
      combined.push(nextRow ? [...sectionsGrid[i], ...nextRow] : sectionsGrid[i]);
    }

    return combined;
  }
}

export default AdapterService;
